<div class="chart-card">
    <h3 class="chart-title">{{ 'pages.collections.analytics.reminder_channel_chart_title' | translate }}</h3>
    <div class="chart-container">
        <canvas baseChart *ngIf="data.length > 0" type="bar" [data]="chartData" [options]="chartOptions"></canvas>
        <div *ngIf="data.length === 0" class="no-data">{{ 'pages.collections.analytics.no_data' | translate }}</div>
    </div>
</div>
